import React from 'react';
import PropTypes from 'prop-types';

const CommitteeBanner = ({ name, badges = null, actions = null }) => (
  <div className="row page-titles bg-light committee-banner">
    <div className="col">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active">
          {badges ? (
            <span className="d-inline-flex align-items-center gap-2">
              <h4 className="text-center mb-0">{name}</h4>
              {badges}
            </span>
          ) : (
            <h4 className="text-center">{name}</h4>
          )}
        </li>
      </ol>
    </div>
    {actions && (
      <div className="col-auto d-flex align-items-center">{actions}</div>
    )}
  </div>
);

CommitteeBanner.propTypes = {
  name: PropTypes.node.isRequired,
  badges: PropTypes.node,
  actions: PropTypes.node,
};

export default CommitteeBanner;
